/* eslint-disable @typescript-eslint/no-explicit-any */
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { FC, useState } from "react";
import ArrowRight from "@/app/csr-src/assets/icons/ArrowRight.svg";
import Styles from "./billingAddressCard.module.scss";
import { useTranslation } from "react-i18next";
import { UserAddressVo } from "@/app/csr-src/apis/checkout/checkout.interface";
import { DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddressBillingList from "@/common-components-src/js/address/addressBillingList";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import UKTruncatedTooltip from "@/common-components-src/components/UKTruncatedTooltip";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25281";

const BillingAddress: FC = observer(() => {
  const { t } = useTranslation();
  const { checkoutStore } = useStores();

  const billingAddress = checkoutStore.billingAddress as UserAddressVo;
  const [isDefault, setIsDefault] = useState(true);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const handleClose = (address: any) => {
    // TODO 这里回调选择的发票地址数据
    console.log("billing address", address);
    checkoutStore.setBillingAddress(address);
    setIsDefault(false);
    setOpenCreateModal(false);
    checkoutStore.setIsBillingAddressEdit(true);
  };

  return (
    <div className={Styles.billingAddressCard}
      exptag={"exp|" + EXPOSURE_RECORD.SettleAccounts_OrderNew_BillAddressExpo}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
    >
      <div className={Styles.label}>{t("checkout.billingAddress.title")}</div>
      <div className={Styles.addressBox} onClick={() => {
        setOpenCreateModal(true);
        //点击事件上报-发票地址楼层点击
        sendClickTrack.SettleAccounts_OrderNew_BillAddress();
      }}>
        <div className={Styles.address}>
          {isDefault && (
            <div className={Styles.defaultAddress}>{t("checkout.billingAddress.default")}</div>
          )}
          {!isDefault && billingAddress && (
            <>
              <UKTruncatedTooltip
                text={billingAddress.name || ""}
                tooltipStyles={Styles.billingName}
                tooltipProps={{ placement: "top" }}
                textLines={1}
              />
              <div>
                <span>+{billingAddress.areaCode}</span> {billingAddress.mobile}
              </div>

              <UKTruncatedTooltip
                text={billingAddress.fullAddress || ""}
                tooltipStyles={Styles.fullAddress}
                tooltipProps={{ placement: "top" }}
                textLines={2}
              />
            </>
          )}
        </div>
        <ArrowRight width={16} style={{ color: "#888B94" }} />
      </div>

      <UKDialog
        open={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        showCloseBtn={true}
        sx={{
          "& .MuiDialog-paper": {
            width: "880px", // 设置自定义宽度
            maxWidth: "none", // 取消最大宽度限制
            maxHeight: "534px",
            minHeight: "334px",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => setOpenCreateModal(false)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <AddressBillingList handleAddressClose={handleClose} data={billingAddress} />
        </DialogContent>
      </UKDialog>
    </div>
  );
});
export default BillingAddress;
